import { render, staticRenderFns } from "./ResellerPaymentStatusBadge.vue?vue&type=template&id=57d38e14"
import script from "./ResellerPaymentStatusBadge.vue?vue&type=script&lang=js"
export * from "./ResellerPaymentStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports